import { isVesselEffectivelyActive } from '../utils/vessel/vesselActivity';

export interface VesselRouteCandidate {
    imoNumber: number | string;
    isActive: boolean;
    isFutureActive?: boolean;
}

export const normalizeImoNumber = (value: unknown): string | null => {
    if (typeof value === 'string' && value.trim() === '') {
        return null;
    }

    const numericValue =
        typeof value === 'number' ? value : typeof value === 'string' ? Number(value.trim()) : Number.NaN;

    if (!Number.isSafeInteger(numericValue) || numericValue <= 0) {
        return null;
    }

    return numericValue.toString();
};

export const isRestoredVesselAvailable = (
    urlImoNumber: string | null,
    vessels: readonly VesselRouteCandidate[],
    includeInactiveVessels: boolean
): boolean => {
    const normalizedUrlImoNumber = normalizeImoNumber(urlImoNumber);
    if (!normalizedUrlImoNumber) {
        return false;
    }

    const vessel = vessels.find((candidate) => normalizeImoNumber(candidate.imoNumber) === normalizedUrlImoNumber);
    return Boolean(vessel && (includeInactiveVessels || isVesselEffectivelyActive(vessel)));
};

export const shouldRedirectToVesselSelection = (
    urlImoNumber: string | null,
    vessels: readonly VesselRouteCandidate[],
    includeInactiveVessels: boolean
): boolean => Boolean(urlImoNumber && !isRestoredVesselAvailable(urlImoNumber, vessels, includeInactiveVessels));
